import { useSelector } from "react-redux";
import AppSkeleton from "../components/Skeletons/AppSkeleton";
import { baseColor, highlightColor } from "../constants/skeletonColor";
import CrossIcon from "../components/svgs/CrossIcon";

const CustomPopupBox = ({
  heading1,
  heading2,
  descrText1,
  descrText2,
  descrText3,
  handleAction,
  handleContinue,
  btnTxt1,
  btnTxt2,
  imgSrc,
  imgClass,
  headingClass,
  descrClass,
  errorMsg,
  successMsg,
  isWhiteBg = false,
  customClass = false,
  popupClass,
}) => {
  const { loader = false } = useSelector((state) => state.app);

  return (
    <div className="popUpContainer">
      <div className={popupClass ? popupClass : "popUpInner"}>
        <div
          className={
            customClass
              ? "customBox noBorder whiteBg"
              : isWhiteBg
              ? "popupBox noBorder whiteBg"
              : "popupBox noBorder"
          }
        >
          <div className="crossIconBox" onClick={() => handleContinue()}>
            <CrossIcon iconColor="#040721" width={18} height={16} />
          </div>

          <div className="logoContainer">
            <div className={imgClass} style={{ background: "none" }}>
              <img src={imgSrc} />
            </div>
            <div className="popupHeader">
              <span className={headingClass}>{heading1}</span>
              <span className={headingClass}>{heading2}</span>
            </div>
          </div>

          <div className="contentContainer">
            <span className={descrClass}>{descrText1}</span>
            <span className={descrClass}>{descrText2}</span>
            <span className={descrClass}>{descrText3}</span>
            <span className="errorMsg">{errorMsg}</span>
            <span className="successMsg">{successMsg}</span>
          </div>

          <div className={customClass ? "passkeyBtn" : "btnContainer"}>
            {loader ? (
              <AppSkeleton
                baseColor={baseColor}
                highlightColor={highlightColor}
                height={84}
                width="313px"
                className="btnLoader"
              />
            ) : (
              <>
                {handleAction && (
                  <button
                    onClick={() => handleAction()}
                    className={loader ? "btnGoldenDisabled" : "btnGolden"}
                    style={{
                      padding: "10px 61px",
                      width: "327px",
                      cursor: "pointer",
                    }}
                    type="button"
                    disabled={loader}
                  >
                    {btnTxt1}
                  </button>
                )}

                {handleContinue && btnTxt2 && (
                  <button
                    onClick={() => handleContinue()}
                    className="btnTransparent"
                    style={{
                      marginTop: "16px",
                      width: "327px",
                      cursor: "pointer",
                    }}
                    type="button"
                    disabled={loader}
                  >
                    {btnTxt2}
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomPopupBox;
